import React from 'react';
import { MessageCircle } from 'lucide-react';

const ConversationList = ({ conversations, selectedId, onSelect, currentUserId, userPresences = {} }) => {
  
  // Get status indicator color
  const getStatusColor = (status) => {
    switch(status) {
      case 'online':
        return 'bg-green-500'; // Yeşil - Çevrimiçi
      case 'busy':
        return 'bg-red-500'; // Kırmızı - Müsait değil
      case 'away':
        return 'bg-yellow-500'; // Sarı - Uzakta
      default:
        return 'bg-gray-400'; // Gri - Çevrimdışı
    }
  };
  
  return (
    <div className="h-full overflow-y-auto">
      {conversations.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-full text-gray-400 dark:text-gray-500">
          <MessageCircle className="w-12 h-12 mb-2" />
          <p>No conversations yet</p>
        </div>
      ) : (
        conversations.map((conv) => {
          const userStatus = userPresences[conv.other_user_id]?.status || 'offline';
          
          return (
            <div
              key={conv.id}
              onClick={() => onSelect(conv.id)}
              className={`p-4 border-b border-gray-200 dark:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors ${
                selectedId === conv.id ? 'bg-red-50 dark:bg-red-900/30 border-l-4 border-red-600 dark:border-red-500' : ''
              }`}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    {/* Online Status Indicator */}
                    <div className="relative">
                      <p className="font-semibold text-gray-900 dark:text-white">{conv.other_user_name}</p>
                      {!conv.trainer_deleted && (
                        <span 
                          className={`absolute -left-3 top-1 w-2.5 h-2.5 rounded-full ${getStatusColor(userStatus)} ring-2 ring-white dark:ring-gray-800`}
                          title={userStatus}
                        />
                      )}
                    </div>
                    {conv.trainer_deleted && (
                      <span className="bg-gray-500 dark:bg-gray-600 text-white text-xs rounded-full px-2 py-0.5 font-medium">
                        Account Deleted
                      </span>
                    )}
                    {conv.unread_count > 0 && (
                      <span className="bg-red-600 text-white text-xs rounded-full px-2 py-0.5">
                        {conv.unread_count}
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-400 truncate mt-1">
                    {conv.last_message || 'No messages yet'}
                  </p>
                </div>
                <span className="text-xs text-gray-400 dark:text-gray-500">
                  {conv.last_message_at
                    ? new Date(conv.last_message_at).toLocaleDateString()
                    : ''}
                </span>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default ConversationList;